(function () {

  'use strict';

  angular.module('eclipseApp.components')

    .controller('storeLocatorCtrl', ['$scope', '$state', 'uteModal', function ($scope, $state, uteModal) {

      $scope.openModal = function () {
        uteModal.open({
          templateUrl: 'modules/my-account/internet/exchange-hardware-modal.html',
          controller: 'exchangeHardwareCtrl'
        });

      };

      $scope.searchCount = 50;
      $scope.showSearchbox = true;
      $scope.pagination = true;
      $scope.initialSearchCategories = ['Eclipse_Sales'];
      //$scope.initialSearchPosition = {B: -79.43429000000003, k: 43.65711};
      //$scope.searchLocation = '8220 Dixie Rd. Brampton';
      $scope.showSearchCategory = false;
      $scope.showMap = false;

    }]);

})();
